import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { apiService } from '../services/api';
import { useBooking } from '../context/BookingContext';
import './Header.css';

const Header = () => {
  const { openBooking } = useBooking();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [navigation, setNavigation] = useState([]);

  useEffect(() => {
    loadNavigation();
  }, []);

  const loadNavigation = async () => {
    try {
      const response = await apiService.getNavigation();
      // Handle both response structures: {success: true, data: [...]} or direct array
      const navData = response.data?.data || response.data || [];
      if (Array.isArray(navData) && navData.length > 0) {
        setNavigation(navData);
      } else {
        // Use default navigation if API returns empty
        setNavigation([
          { label: 'Home', url: '/', order_position: 1 },
          { label: 'About Us', url: '/about', order_position: 2 },
          { label: 'Services', url: '/services', order_position: 3 },
          { label: 'Our Plans', url: '/plans', order_position: 4 },
          { label: 'Contact Us', url: '/contact', order_position: 5 }
        ]);
      }
    } catch (error) {
      console.error('Error loading navigation:', error);
      // Use default navigation if API fails
      setNavigation([
        { label: 'Home', url: '/', order_position: 1 },
        { label: 'About Us', url: '/about', order_position: 2 },
        { label: 'Services', url: '/services', order_position: 3 },
        { label: 'Our Plans', url: '/plans', order_position: 4 },
        { label: 'Contact Us', url: '/contact', order_position: 5 }
      ]);
    }
  };
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/" onClick={closeMenu}>
              <div className="logo-icon">
                <img src="/images/sam_logo.png" alt="Sampoorna Logo" width="230" height="90" />
              </div>
            </Link>
          </div>
          <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              {navigation.map((item, index) => (
                <li key={item.id || index}>
                  <Link to={item.url} className={isActive(item.url)} onClick={closeMenu}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <button
            type="button"
            className="btn-book-appointment"
            onClick={() => openBooking({ title: 'Book an Appointment' })}
          >
            Book Appointment
          </button>
          <button 
            className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
